import { useSelector } from "react-redux";
import {
  selectDuration,
  selectProgress,
} from "../../redux/selectors/playerSelector";
import { formatLeftTime } from "../../utils/formatLeftTime";
import Typography from "../Typography";
import { AudioDuration as StyledAudioDuration } from "./styled";

export const AudioDuration = () => {
  const progress = useSelector(selectProgress);
  const duration = useSelector(selectDuration);

  return (
    <Typography as={StyledAudioDuration}>
      <span>Осталось:</span> {formatLeftTime(duration - progress)}
    </Typography>
  );
};
